/**
 * 初始化懒加载逻辑
 * @param {HTMLElement} imgEl 图片 DOM 节点
 * @param {Function} callback 图片进入视口时调用的回调函数
 * @param {Object} options 配置选项，支持 threshold 和 rootMargin
 *    - threshold: 数字或数字数组，默认为 0.1
 *    - rootMargin: 字符串，默认为 "50px 1000px"
 * @returns {IntersectionObserver|undefined} 返回创建的 IntersectionObserver 实例（如果支持）
 */
export function setupLazyImage(imgEl, callback, options = {}) {
    if (!imgEl) return;
    
    const {
      threshold = 0.1,
      rootMargin = "50px 1000px"
    } = options;
  
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        // entries 是被观察的元素集合，这里只观察一个元素，所以直接取第一个
        const [entry] = entries;
        if (entry && entry.isIntersecting) {
          callback && callback();
          // 标记该元素已绑定，防止重复初始化
          imgEl.setAttribute("data-lazy-bound", "true");
          obs.disconnect();
        }
      }, {
        threshold: Array.isArray(threshold) ? threshold : [threshold],
        rootMargin
      });
      observer.observe(imgEl);
      return observer;
    } else {
      // 不支持 IntersectionObserver 时直接加载
      callback && callback();
    }
  }
  